import Vue from 'vue'

const actions = {
    async Chat(_, payload) {
        try {
            const result = await Vue.prototype.$vanKirkApi.post('ai/assistant/chat', payload, {
                headers: {
                    'content-type': 'application/json'
                }
            });

            if (result && result.data && result.data.success) {
                return result.data.result;
            }

            return {
                success: false,
                message: result && result.data && result.data.message ? result.data.message : 'Error communicating with assistant.'
            };
        }
        catch (ex) {
            return {
                success: false,
                message: ex && ex.response && ex.response.data && ex.response.data.message
                    ? ex.response.data.message
                    : 'Could not contact the assistant. Please try again.'
            };
        }
    }
};

export default {
    namespaced: true,
    actions
};
